import { FC, SVGProps } from 'react'

export const OpenLock: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.1668 9.16602H6.50016C5.57969 9.16602 4.8335 9.91221 4.8335 10.8327V16.666C4.8335 17.5865 5.57969 18.3327 6.50016 18.3327H18.1668C19.0873 18.3327 19.8335 17.5865 19.8335 16.666V10.8327C19.8335 9.91221 19.0873 9.16602 18.1668 9.16602Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.16699 9.16602V5.83268C1.16699 4.72761 1.60598 3.66781 2.38738 2.8864C3.16878 2.105 4.22859 1.66602 5.33366 1.66602C6.43873 1.66602 7.49854 2.105 8.27994 2.8864C9.06134 3.66781 9.50033 4.72761 9.50033 5.83268V9.16602"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
